import {
  IAnnealedWireType,
  IDiameter,
  IPieceType,
  ISteelType
} from '../../store/ducks/fabrication/types';
import { sortArrayAlphabeticallyByField } from '../../utils/sortArrays';
import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EGerdauService } from '../EGerdauService';

export class FabricationService extends EGerdauService {
  async getPieceTypes(): Promise<IPieceType[]> {
    const headers = super.getHeaders();
    const pieceTypesResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.PIECE_TYPES}`,
      { headers }
    );

    const pieceTypes = pieceTypesResponse.data as IPieceType[];

    sortArrayAlphabeticallyByField(pieceTypes, 'description');

    return pieceTypes;
  }

  async getSteelTypes(): Promise<ISteelType[]> {
    const headers = super.getHeaders();
    const steelTypesResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.STEEL_TYPES}`,
      { headers }
    );
    const steelTypes = steelTypesResponse.data as ISteelType[];

    sortArrayAlphabeticallyByField(steelTypes, 'description');

    return steelTypes;
  }

  async getDiametersFromSteelTypeId(steelTypeId: number): Promise<IDiameter[]> {
    const headers = super.getHeaders();
    const diametersResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.DIAMETER}/${steelTypeId}`,
      { headers }
    );
    return diametersResponse.data as IDiameter[];
  }

  async getAnnealedWireTypes(
    annealedWireIds: string[]
  ): Promise<IAnnealedWireType[]> {
    const headers = super.getHeaders();

    const bodyRequest = {
      annealedWireType: annealedWireIds.map((annealedWireId) => {
        return {
          annealedWireId
        };
      })
    };

    const wireTypesResponse = await customersAuthorizationApi.post(
      `${ECustomerAuthorizationEndpoints.ANNEALED_WIRE_TYPES}`,
      { ...bodyRequest },
      { headers }
    );
    const wireTypes = wireTypesResponse.data
      .annealedWireType as IAnnealedWireType[];

    sortArrayAlphabeticallyByField(wireTypes, 'description');

    return wireTypes;
  }
}
